<template>
  <div class="container">
    <div class="row">
      <div class="col-lg" style="text-align: center">
        <log-out/>
      </div>
    </div>
  </div>
</template>

<script>
  import LogOut from './LogOut'

  export default {
    name: 'LogOut',
    components: {
      logOut: LogOut
    }
  }
</script>
